import { createClinicPrescription } from "../../../../api/clinic/consultationApi.js";
import { saveConsultationServices } from "../../../../api/clinic/consultationApi.js";

export const processPrescription = async (consultationData, consultationId, prescriptionDraft, services = []) => {
  if (!prescriptionDraft || !Array.isArray(prescriptionDraft.medications) || !prescriptionDraft.medications.length) {
    return;
  }

  const items = (prescriptionDraft.medications || []).map((m) => {
    const directions = m.instructions === "Other" ? (m.instructionsOther || "") : (m.instructions || "");
    return {
      sku: m.sku ?? null,
      itemName: m.drugName || null,
      quantity: m.quantity ?? 1,
      directions,
    };
  });

  // Create clinic prescription with medications
  const prescriptionResult = await createClinicPrescription({
    patientid: consultationData?.patientId,
    consultationid: consultationId,
    appointmentid: consultationData?.appointmentId,
    repeatscript: prescriptionDraft.repeatScript ? (prescriptionDraft.repeatCount || 0) : 0,
    chronic: !!prescriptionDraft.chronicMedication,
    items,
  });

  // Save consultation services if provided
  if (services && services.length > 0) {
    try {
      await saveConsultationServices(consultationId, services);
    } catch (e) {
      console.error("Failed to save consultation services:", e);
      // Don't throw error - prescription creation is more important
    }
  }

  return prescriptionResult;
};
